import React from 'react';
import { Play, X } from 'lucide-react';
import { COLORS } from '../shared/ContentData';

const PlayButton = ({ isPlayMode, setIsPlayMode, isMobile }) => {
  const buttonStyle = {
    position: 'fixed',
    right: isMobile ? '20px' : '40px',
    top: isMobile ? '20px' : '40px',
    backgroundColor: COLORS.content,
    borderRadius: '50%',
    width: '60px',
    height: '60px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    transition: 'transform 0.3s ease, background-color 0.3s ease',
    zIndex: 50,
    border: 'none',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    color: COLORS.text
  };

  const hoverStyle = {
    transform: 'scale(1.1)',
    backgroundColor: COLORS.background
  };

  return (
    <button
      style={buttonStyle}
      onClick={() => setIsPlayMode(!isPlayMode)}
      aria-label={isPlayMode ? "Exit Play Mode" : "Enter Play Mode"}
      onMouseEnter={(e) => Object.assign(e.target.style, hoverStyle)}
      onMouseLeave={(e) => Object.assign(e.target.style, buttonStyle)}
    >
      {isPlayMode ? <X size={24} /> : <Play size={24} />}
    </button>
  );
};

export default PlayButton;